export default __webpack_public_path__ + "static/media/28t.04d9ae32.jpg";